enum Journal {
  revenue = "revenue",
  cost = "cost",
}

export default Journal;
